import React, { useState, useRef } from 'react';

const ListOfSectionMenu = ({ module, sections = [], onNavigateSection }) => {

    const [showSub, setShowSub] = useState(false);
    const titleRef = useRef(null);
    const hideTimer = useRef(null);

    const show = () => { clearTimeout(hideTimer.current); setShowSub(true); };
    const hide = () => { hideTimer.current = setTimeout(() => setShowSub(false), 150); };

    const navigateSection = (sectionNo) => {
        if (typeof onNavigateSection === 'function') onNavigateSection(sectionNo);
    };

    // sections with subFolders then use subFolders as sections
    if (sections.length === 1 && sections[0]?.subFolders) {
        const subFoldersArray = Array.isArray(sections[0].subFolders) ? sections[0].subFolders : Object.values(sections[0].subFolders);
        if (subFoldersArray.length > 0) {
            const parentStats = sections[0]?.stats || { completionPercent: 0, riskPercent: 0 };
            sections = subFoldersArray.map(sub => ({
                sectionName: sub.name,
                sectionNo: sub.no,
                stats: parentStats,
                questions: sub.questions || []
            }));
        }
    }

    return (
        <>
            <div ref={titleRef} className="ds-module-menu__title cp" onMouseEnter={show} onMouseLeave={hide}>
                <div className="df aic">
                    <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/list.png')} alt="list-of-sections" />
                    <span>List of Sections</span>
                </div>
                <img style={{ height: '10px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/arrow.png')} alt="arrow-right" />
            </div>
            <div className="ds-module-menu__divider" />
            {showSub && (
                <div
                    className="ds-module-menu__sub"
                    onMouseEnter={show}
                    onMouseLeave={hide}
                >
                <span className="tooltip-area">
                    {sections.length > 0 &&
                        <span className={`tooltip-area ${(module?.heading === "Investor Match" || (sections.length && sections.length < 8)) ? 'tooltip-top-important' : ''}`}>
                            {sections.map((section, idx) => {
                                if (!section.stats) section.stats = module?.['module']?.['sections']?.[0]?.['stats'] || module?.['sections']?.[0]?.['stats'] || { completionPercent: 0, riskPercent: 0 };
                                const completeness = section.stats.completionPercent || 0;

                                let riskColour;
                                if (module.type === "repository" || (section.stats.riskPercent || 0) < 38) riskColour = 7;
                                else if (section.stats.riskPercent > 62) riskColour = 9;
                                else riskColour = 8;

                                let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";

                                let colorChange = false;
                                if (module['type'] == "warranty-disclosure") {
                                    if (section?.questions && section?.questions.length > 0) section?.questions.map(question => {
                                        if (question?.['answer']?.['radioOption'] == 'Disclosure' || question?.['answer']?.['radioOption'] == 'Not Sure') {
                                            colorChange = true;
                                            return;
                                        }
                                    })
                                }
                                return (
                                    <button
                                        key={idx}
                                        onClick={() => navigateSection(section['sectionNo'])}
                                        style={{ background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` }}
                                        data-scroll-to={section['sectionNo']}
                                        className="overlay-box tal w100 tac cp c3-hover"
                                    >
                                        <span>{section['sectionName']}</span>
                                    </button>
                                );
                            })}
                        </span>
                    }
                </span>
            </div>
            )}
        </>
    );
};

export default ListOfSectionMenu;
